import { render, staticRenderFns } from "./NotiPopup.vue?vue&type=template&id=014302ff&scoped=true"
import script from "./NotiPopup.ts?vue&type=script&lang=ts&external"
export * from "./NotiPopup.ts?vue&type=script&lang=ts&external"
import style0 from "./NotiPopup.vue?vue&type=style&index=0&id=014302ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014302ff",
  null
  
)

export default component.exports